module.exports = __webpack_public_path__ + "static/media/eceb2.f3d8cd37.png";